import { Api } from "../Api/Api"

export const getAllUserEntryApi = (user_data) => Api.post('api/getAllUsersAttendance',user_data);

export const getUserEntryApi = (entry_data) => Api.post('api/getUserAttendance',entry_data)
    